import React from 'react';
import { SmartDataTable } from '@src/components/SmartDataTable';
import { useTransactionsColumns } from './hooks/useTransactionsColumns';
import { useTransactionsFormFields } from './hooks/useTransactionsFormFields';

interface TransactionsTabProps {
  patientId?: string | number;
}

export const TransactionsTab: React.FC<TransactionsTabProps> = ({
  patientId,
}) => {
  const columns = useTransactionsColumns();
  const formFields = useTransactionsFormFields(patientId);

  if (!patientId) {
    return null;
  }

  return (
    <div style={{ height: '100%', overflow: 'hidden' }}>
      <SmartDataTable
        api={{
          resource: `transactions`,
          defaultParams: {
            filters: [
              {
                field: 'patient_id',
                operator: 'eq',
                value: patientId,
              },
            ],
          },
        }}
        title="Transactions"
        columns={columns}
        createForm={{
          fields: formFields as any,
          title: 'Create Transaction',
          submitText: 'Create Transaction',
          initialValues: {
            patient_id: patientId,
          },
        }}
        editForm={{
          fields: formFields as any,
          title: 'Edit Transaction',
          submitText: 'Save Changes',
        }}
        formDisplayMode="modal"
        drawerWidth={600}
        showCreate={true}
        showEdit={true}
        showDelete={true}
        showView={false}
        pageSize={10}
        showSizeChanger={true}
        showQuickJumper={false}
        showExport={false}
        showColumnVisibility={true}
        tableProps={{
          scroll: {
            x: 'max-content',
            y: 'calc(100vh - 375px)',
          },
        }}
        rowKey="id"
        style={{
          height: '100%',
        }}
      />
    </div>
  );
};
